export default {
    infoData: {
        companyName: '',
        siteName: '',
        ledgerName: '',
        businessType: '',
        feeTaskType: '',
        noTaxAmount: '',
        amount: '',
        remark: '',
        taxAmount: '',
        supplierComfirmAmount: ''
    },
    tableDataItems: [
        {
            prop: 'businessTime',
            label: '计费日期'
        },
        {
            prop: 'volume',
            label: '体积(m³)',
            type: 'normal'
        },
        {
            prop: 'weight',
            label: '重量(kg)',
            type: 'normal'
        },
        {
            prop: 'quantity',
            label: '数量',
            type: 'normal'
        },
        {
            prop: 'noTaxAmount',
            label: '不含税费用',
            type: 'normal'
        },
        {
            prop: 'taxRate',
            label: '税率',
            type: 'normal'
        },
        {
            prop: 'taxAmount',
            label: '税额',
            type: 'normal'
        },
        {
            prop: 'amount',
            label: '含税费用',
            type: 'normal'
        },
        {
            prop: 'supplierAmount',
            label: '确认金额',
            type: 'normal'
        },
        {
            prop: 'supplierMsg',
            label: '备注',
            type: 'normal'
        },
        {
            prop: 'replyMsg',
            label: '安得回复',
            type: 'normal'
        }
    ],
    costTableDataItems: [
        {
            prop: 'feeHeaderName',
            label: '费用名称',
            type: 'normal',
            width: '100'
        },
        {
            prop: 'custBusNo',
            label: '客户订单号',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'bussOrderType',
            label: '订单类型',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'whName',
            label: '仓库名称',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'cdcmMaterialNo',
            label: '客户商品编码',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'cdcmNameCn',
            label: '商品名称',
            width: '220',
            type: 'normal'
        },
        {
            prop: 'volume',
            label: '体积(m³)',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'grossWeight',
            label: '重量(Kg)',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'quantity',
            label: '数量',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'ebmgCode',
            label: '商品分类编码',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'ebmgNameCn',
            label: '商品分类名称',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'commodityGroupName',
            label: '产品组',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'closeTime',
            label: '订单关闭日期',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'price',
            label: '单价',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'fee',
            label: '不含税成本',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'taxrate',
            label: '税率',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'tax',
            label: '税额',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'amount',
            label: '含税成本',
            width: '150',
            type: 'normal'
        }
    ]
};
